export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const RUBRICAS = [
  { key: 'comissao_servicos', label: 'Comissao Servicos' },
  { key: 'comissao_produtos', label: 'Comissao Produtos' },
  { key: 'ao', label: 'AO — Ajuda Operacional' },
  { key: 'royalties_individual', label: 'Royalties Individual' },
  { key: 'royalties_equipe', label: 'Royalties Equipe' },
  { key: 'meta_geral', label: 'Meta Geral' },
];

export const CATEGORIAS = [
  { key: 'profissional', label: 'Profissional' },
  { key: 'auxiliar', label: 'Auxiliar' },
  { key: 'recepcao', label: 'Recepcao' },
  { key: 'gerente', label: 'Gerente' },
  { key: 'estagiario', label: 'Estagiario' },
  { key: 'outro', label: 'Outro' },
];

export const STATUS_FECHAMENTO = {
  nao_gerado: { label: 'Nao gerado', color: '#A1A1AA', bg: '#F4F4F5' },
  rascunho: { label: 'Rascunho', color: '#B45309', bg: '#FFFBEB' },
  finalizado: { label: 'Finalizado', color: '#1B4332', bg: '#F0FDF4' },
};

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0);
};

export const MESES = [
  'Janeiro', 'Fevereiro', 'Marco', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];
